import { isEmpty, isNil, keys } from 'lodash'

export const makeUrl = (url, params = {}) => {
    if (!isEmpty(params)) {
        url += `?${keys(params)
            .filter(key => !isNil(params[key]))
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
            .join('&')}`
    }
    return url
}
